export default "__VITE_ASSET__CdE5RdeY__"